/* eslint-disable @typescript-eslint/no-empty-function */
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSTKContext } from '@/context/context';
import { useNamedPricePriceDeviations } from '@/services/namedPrice/namedPrice.service';
import { PriceDeviationResponse } from '@/types/menus.types';
import { PriceDeviationsDrawerShared } from '@/pages/Franchisee/SharedComponents/PriceDeviations/PriceDeviationsDrawerShared';

export interface NamedPricePriceDeviationsDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  namedPriceId: string;
  selectedGroupName: string;
  cameFromEditDrawer?: boolean;
  firstColumnHeader?: string;
}

export const NamedPricePriceDeviationsDrawer: FC<NamedPricePriceDeviationsDrawerProps> = ({
  isOpen,
  onClose,
  namedPriceId,
  selectedGroupName,
  cameFromEditDrawer,
  firstColumnHeader,
}) => {
  const { t } = useTranslation();
  const { storesAndGroups } = useSTKContext();

  const selectedStores = useMemo(() => {
    if (!storesAndGroups) return [];
    if (storesAndGroups.origin === 'tab-stores-groups') {
      return storesAndGroups.storeGroups?.find((item) => item.storeGroup === selectedGroupName)?.stores ?? [];
    }
    return (
      storesAndGroups.stores?.filter((item) => item.storeGroup === selectedGroupName).map((item) => item.storeNo) ?? []
    );
  }, [storesAndGroups, selectedGroupName]);

  const { data, isLoading } = useNamedPricePriceDeviations(isOpen && !!namedPriceId, namedPriceId, selectedStores);

  const tableData: PriceDeviationResponse[] = useMemo(() => {
    if (!data) return [];
    return [
      {
        productName: data.name,
        productDescription: '',
        variantId: data.namedPriceId,
        majorityPricePoint: data.majorityPricePoint ?? null,
        priceDeviations: data.priceDeviations,
      },
    ];
  }, [data]);

  return (
    <PriceDeviationsDrawerShared
      isOpen={isOpen}
      onClose={onClose}
      selectedGroupName={selectedGroupName}
      data={tableData}
      isLoading={isLoading}
      cameFromEditDrawer={cameFromEditDrawer}
      firstColumnHeader={firstColumnHeader ?? t('priceDeviations.table.bundleAddOn')}
      closeButtonTestId="named-price-price-deviations-close"
      backButtonTestId="named-price-price-deviations-back"
    />
  );
};

export default NamedPricePriceDeviationsDrawer;
